import { Component, OnDestroy } from '@angular/core';
import { Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as ReportingActions from '@reporting/reporting.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromReporting from '@reporting/reporting.reducers';

import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-reporting-transactions',
  templateUrl: './reporting-transactions.component.html',
  styleUrls: ['./reporting-transactions.component.scss'],
  standalone: false
})
export class ReportingTransactionsComponent implements OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  customer: Customer;
  currentAccountDetail: CustomerAccount;
  transactions = [];

  currentPage: number;
  startIndex: number;
  endIndex: number;
  pages: number;
  pagesSelectionOptions: number[];

  constructor(
    private store: Store,
    private trackingService: TrackingService
  ) {
    this.store.pipe(select(fromReporting.selectTransactionsUpdated), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.transactions = response;
    });
    this.store.pipe(select(fromReporting.selectTransactionsPagedInfo), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.pages = response.numberOfPages;
      this.pagesSelectionOptions = this.getSelectionPages(this.pages);
      this.currentPage = response.currentPage;
      this.startIndex = response.startIndex;
      this.endIndex = response.endIndex;
    });
    this.store.pipe(select(fromAppRoot.selectCustomerAndCurrentInvestAccount), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.customer = value.customer;
      this.currentAccountDetail = value.currentAccountDetail;
    });
  }

  track(event: string): void {
    this.trackingService.trackActivity(event);
  }

  updatePagination(index: number): void {
    this.store.dispatch(ReportingActions.updateTransactionsPagination({ currentPage: index }));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private getSelectionPages(pages: number): number[] {
    if (pages > 7) {
      return [...Array(3).keys()].concat([...Array(pages).keys()].slice(-3));
    }
    return [...Array(pages).keys()];
  }
}
